import { render, staticRenderFns } from "./ModalDetailsProduct.vue?vue&type=template&id=0af57448&scoped=true"
import script from "./ModalDetailsProduct.vue?vue&type=script&lang=js"
export * from "./ModalDetailsProduct.vue?vue&type=script&lang=js"
import style0 from "./ModalDetailsProduct.vue?vue&type=style&index=0&id=0af57448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af57448",
  null
  
)

export default component.exports